import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import { DataService } from '../../services/data/data.service';

@Component({
	selector: 'pcm-date-jump-to',
	templateUrl: './date-jump-to.component.html',
	styleUrls: ['./date-jump-to.component.scss']
})
export class DateJumpToComponent {
	@Input() label: string = 'Jump to Date';
	@Input() minDate: NgbDateStruct;
	@Input() maxDate: NgbDateStruct;
	@Input() tooltipText: string;
	// Joy Ride Tour step
	@Input() joyRideStep: any = {
		id: 'dateJumpTo',
		title: '',
		text: ''
	};
	/**
	 * action emitted when hovering over calendar button, presumably for updating any date range restrictions before opening the calendar
	 */
	@Output() hoverCalendarButton: EventEmitter<void> = new EventEmitter<void>();
	/**
	 * when clicking the action button, emit the date object converted to a string if available, otherwise return the text in the input field
	 */
	@Output() actionButtonPressed: EventEmitter<any> = new EventEmitter<any>();

	currentDate: NgbDateStruct;
	currentDateText: string;

	constructor(private dataService: DataService) {}

	handleActionButtonPressed(): void {
		if (this.currentDate) {
			this.actionButtonPressed.emit(this.dataService.formatPickerDate(this.currentDate));
			return;
		}
		// check if text in field is valid date, otherwise don't emit
		const d = new Date(this.currentDateText);
		if (!isNaN(d.getTime())) {
			this.actionButtonPressed.emit(this.currentDateText);
		}
	}

	handleButtonMouseEnter() {
		this.hoverCalendarButton.emit();
	}

	handleCalendarChange() {
		if (this.currentDate.day && this.currentDate.year && this.currentDate.month) {
			this.currentDateText = this.dataService.formatPickerDate(this.currentDate);
		}
	}

	// clear selected date if typing into text field
	handleDateTextChanged() {
		if (this.currentDate) {
			this.currentDate = undefined;
		}
	}
}
